const projectServices = [
  {
    icon: '🌐',
    title: 'Website Development',
    slug: 'website-development',
    tagline: 'Professional Online Presence for Your Business',
    simple: 'We create beautiful, fast, and easy-to-use websites that help your business succeed online.',
    professional: 'Magbity Agency delivers custom website development solutions including responsive design, e-commerce platforms, content management systems, and web applications built with the latest technologies to ensure your online presence is professional, secure, and user-friendly.',
    details: [
      'Responsive and mobile-optimized websites',
      'E-commerce and online store solutions',
      'Content Management Systems (CMS)',
      'Web application development',
      'SEO optimization and performance',
      'Website security and maintenance'
    ]
  },
  {
    icon: '📱',
    title: 'App Development',
    slug: 'app-development',
    tagline: 'Innovative Mobile & Web Applications',
    simple: 'We build mobile apps and web applications that make your service accessible to everyone, everywhere.',
    professional: 'We design and develop native and cross-platform mobile applications, web apps, and progressive web applications (PWAs) with intuitive user interfaces, robust functionality, and seamless performance across all devices.',
    details: [
      'iOS and Android app development',
      'Cross-platform mobile applications',
      'Progressive Web Apps (PWA)',
      'User experience (UX) design',
      'App testing and quality assurance',
      'App deployment and ongoing support'
    ]
  },
  {
    icon: '🎨',
    title: 'Graphic Design',
    slug: 'graphic-design',
    tagline: 'Creative Visual Solutions for Your Brand',
    simple: 'We create stunning graphics, logos, and designs that make your brand stand out and look professional.',
    professional: 'Magbity Agency provides comprehensive graphic design services including brand identity, visual communication, marketing materials, and creative assets that engage your audience and elevate your brand presence.',
    details: [
      'Logo and brand identity design',
      'Branding and visual guidelines',
      'Marketing and promotional materials',
      'Social media graphics and content',
      'Print and digital design',
      'Packaging and product design'
    ]
  }
];

export default projectServices;
